import { render, staticRenderFns } from "./FooterComponentKh.vue?vue&type=template&id=d8901f20&scoped=true"
import script from "./FooterComponentKh.vue?vue&type=script&lang=ts"
export * from "./FooterComponentKh.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentKh.vue?vue&type=style&index=0&id=d8901f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8901f20",
  null
  
)

export default component.exports